import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
  fill?: string;
}

const ContactIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "ContactIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M15.3697 16.119C15.1779 16.119 14.986 16.0458 14.8395 15.8993L8.10022 9.1605C7.80725 8.86753 7.80725 8.39292 8.10022 8.09995C8.39319 7.80698 8.8678 7.80698 9.16077 8.09995L15.9 14.8387C16.193 15.1317 16.193 15.6063 15.9 15.8993C15.7535 16.0457 15.5616 16.119 15.3697 16.119Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M8.63049 16.119C8.4386 16.119 8.2467 16.0458 8.10022 15.8993C7.80725 15.6063 7.80725 15.1317 8.10022 14.8387L14.8395 8.09996C15.1324 7.80699 15.6071 7.80699 15.9 8.09996C16.193 8.39293 16.193 8.86754 15.9 9.16051L9.16077 15.8993C9.01429 16.0458 8.82238 16.119 8.63049 16.119Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12 22.0005C6.48619 22.0005 2 17.5143 2 12.0005C2 6.48667 6.48619 2.00049 12 2.00049C17.5138 2.00049 22 6.48668 22 12.0005C22 17.5143 17.5138 22.0005 12 22.0005ZM12 3.53518C7.33197 3.53518 3.53471 7.33246 3.53471 12.0005C3.53471 16.6685 7.33198 20.4658 12 20.4658C16.668 20.4658 20.4653 16.6685 20.4653 12.0005C20.4653 7.33246 16.668 3.53518 12 3.53518Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default ContactIcon;
